import React, { useEffect, useState } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { dispatchService } from '../../../services/central-api/dispatch';
import { StyleProp, TextStyle } from 'react-native';
import { ModeType } from 'react-native-dropdown-picker';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

type Props = {
    actingBodyId: number | null;
    zIndex: number;
    disabled?: boolean;
    unitId?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
    mode: ModeType;
    dropdownLabelStyle?: StyleProp<TextStyle>;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function EquipmentsDropdown({ form, fieldName, value, setValue, actingBodyId, disabled, zIndex, unitId, labelStyle, dropdownLabelStyle, viewStyle, label, mode = 'BADGE' }: Props) {
    const [selectableEquipments, setSelectableEquipments] = useState<{ label: string; value: number; }[]>([]);

    async function getEquipments({ actingBodyId }: { actingBodyId: number; }) {
        try {
            const equipments = await dispatchService.getUnitsSimplifiedEquipments(actingBodyId, unitId);
            setSelectableEquipments(equipments.map((item: DropdownResource) => {
                return {
                    label: item.name, value: item.id
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getEquipments({ actingBodyId });
        }
    }, [actingBodyId, unitId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('equipments')}
            items={selectableEquipments}
            multiple={true}
            zIndex={zIndex}
            disabled={disabled}
            fieldName={fieldName}
            form={form}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            mode={mode}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={label ?? translate('equipments')}
                items={selectableEquipments}
                multiple={true}
                setValue={setValue}
                value={value}
                disabled={disabled}
                zIndex={zIndex}
                mode={mode}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
                dropdownLabelStyle={dropdownLabelStyle}
            />
        );
    }
}

export default EquipmentsDropdown;
